export const isRedirectRequest = (location: Location) => {
  const urlHash = location.hash;
  const urlQuery = location.search;

  if (urlHash && urlHash.length > 1) {
    const hashContent =
      urlHash.charAt(0) === '#' ? urlHash.substring(1) : urlHash;
    const hashParams = new URLSearchParams(hashContent);
    if (hashParams.has('state')) {
      return true;
    }
  }

  if (urlQuery && urlQuery.length > 1) {
    const queryContent =
      urlQuery.charAt(0) === '?' ? urlQuery.substring(1) : urlQuery;
    const queryParams = new URLSearchParams(queryContent);
    if (queryParams.has('state')) {
      return true;
    }
  }

  return false;
};
